<template>
  <!-- 手写select组件 -->
  <div class="select-container" ref="prent">
    <div class="info" @click="handleShow(!show)">
      <span v-show="value===''" class="place">{{ placeholder }}</span>
      <span v-show="value!==''" class="value">{{ selectTable }}</span>
      <span></span>
      <van-icon class="icon" :class="{ active: show }" name="arrow-down" />
    </div>
    <div
      class="triangle"
      ref="triangle"
      v-show="show"
      :style="{
        borderBottomColor: bgColor,
      }"
    ></div>
    <div class="huabu" v-show="show" @click="handleShow(!show)"></div>
    <div
      v-show="show"
      class="popup-container"
      :style="{ width: width }"
      ref="childr"
    >
      <ul>
        <li
          @click="li(item)"
          v-for="item in valueList"
          :key="item.table"
          :style="{ color: fontColor }"
        >
          {{ item.table }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    props: "value",
    event: "change",
  },
  props: {
    valueList: {
      type: Array,
      default: () => [],
    },
    //显示的内容
    value: {},
    //内容宽度
    width: {
      type: String,
      default: "100%",
    },
    //提示信息
    placeholder:{
      type:String,
      default:'请选择'
    },
    //字体颜色
    fontColor: {
      type: String,
      default: "#fff",
    },
    //选中的颜色
    selectColor: {
      type: String,
      default: "#C59770",
    },
    //背景颜色
    bgColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      show: false,
      selectTable: "", //显示选择的值
    };
  },
  methods: {
    handleShow(state) {
      this.show = state;
    },
    li(value) {
      if (value.value === -1) {
        this.selectTable = "";
        this.$emit("change", "");
      } else {
        this.selectTable = value.table;
        this.$emit("change", value.value);
      }
      this.show = false;
    },
  },
  mounted() {
    const { prent, childr } = this.$refs;
    childr.style.top = prent.offsetHeight + 19 + "px";
  },
};
</script>

<style lang="less" scoped>
.select-container {
  font-size: 14px;
  position: relative;
  height: 100%;
  .info {
    height: 100%;
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: space-between;
    background-color: #fff;

    .icon {
      transition: all 0.3s;
      &.active {
        transform: rotate(180deg);
      }
    }
    .place {
      color: #969799;
    }
  }
  .huabu {
    position: fixed;
    z-index: 2999;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: transparent;
  }
  .triangle {
    height: 0px;
    width: 0px;
    border: 10px solid;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3000;
    border-top-color: transparent;
    border-right-color: transparent;
    border-left-color: transparent;
  }
  .popup-container {
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
    position: absolute;
    box-sizing: border-box;
    border-radius: 5px;
    z-index: 3000;
    left: 50%;
    background-color: #fff;
    transform: translateX(-50%);
    ul {
      li {
        padding: 8px;
        text-align: center;
        color: #999;
        position: relative;
        &::after {
          content: " ";
          position: absolute;
          left: 0;
          bottom: 0;
          pointer-events: none;
          box-sizing: border-box;
          transform-origin: 0 0;
          width: 100%;
          height: 1px;
          transform: scaleY(0.5);
          background-color: #e4e7ed;
        }
      }
    }
  }
}
</style>